import React from 'react';
import { withRouter } from 'react-router-dom';
import Item from './Item';
import Log from '../../utils/log';

export const showError = (detail) => Log.error(
  `ATTENZIONE[${detail}]: Si sta usando una vecchia versione di react-router. Si consiglia quanto prima di aggiornare questo pacchetto.`,
);

/**
 * HOC per tentare il caricamento dell'item com wihRouter. Nel caso
 * venisse utilizzata una vecchia versione di react-router o non
 * sia in ogni caso possibile caricare withRouter, verrà comunque
 * caricamento il componente e verrà usato eventualmente
 * il context.router
 */
const ItemWR = withRouter(Item);
const ItemFinal = class extends React.Component {
  state = {
    newRouter: true,
  }

  componentDidCatch() {
    const { link, content } = this.props; // eslint-disable-line react/prop-types
    showError(content || link || '?');
    this.setState({ newRouter: false });
  }

  render() {
    const { newRouter } = this.state;
    return newRouter ? <ItemWR {...this.props} /> : <Item {...this.props} />;
  }
};

export default ItemFinal;
